package gr.tech.models.storeusers

import kotlinx.serialization.Serializable

@Serializable
data class StoreUsersInviteDTO(
    val uuid: String,
    val token: String?,
    val email: String?,
    val notes: String?,
    val storeId: Int,
    val status: Short,
    val createdAt: String,
    val createdByAdminUuid: String,

    // augments
    val storeName: String?,
)
